import { Component, OnInit, Input } from '@angular/core';
import { Validators, FormBuilder, FormArray, FormGroup, FormControl } from '@angular/forms';
import { FlashMessagesService } from 'angular2-flash-messages';
import { saveAs } from 'file-saver';

import { CommonService } from '../../../common/service/common.service';
import { LimitFlowProposalService } from '../../service/limit-flow-proposal/limit-flow-proposal.service';

@Component({
	selector: 'app-rating',
	templateUrl: './rating.component.html',
	styleUrls: ['./rating.component.scss'],
	providers: [
		CommonService
	]
})
export class RatingComponent implements OnInit {

	@Input('proposalID') proposalID: string = "";
	@Input('proposalLayout') proposalLayout: number = 0;
	@Input('proposalStatus') proposalStatus: string = "";
	@Input('isUserOwner') isUserOwner: boolean = false;

	revenueRural: FormGroup;
	private token;
	allowedFileSize: number;
	allowedFiles: string = "";

	public dre: {
		DemonstrativoFinanceiroID: '',
		Rating: ''
	};

	constructor(private fb: FormBuilder, private limitFlowProposalService: LimitFlowProposalService, private flashMessagesService: FlashMessagesService, private commonService: CommonService) {
	}

	ngOnInit() {
		console.log("Load Rating Tab");
		this.token = localStorage.getItem('yara.token');

		this.dre = $("#dreObj").val() ? JSON.parse($("#dreObj").val().toString()) : [];

		if (this.dre.DemonstrativoFinanceiroID && this.dre.DemonstrativoFinanceiroID !== "00000000-0000-0000-0000-000000000000") {
			this.getRatingById(this.dre.DemonstrativoFinanceiroID);	
		}
	}

	getRatingById(id) {
		this.limitFlowProposalService.getRatingById(id).subscribe(result => {
			if (result.Success) {
				console.log(result.Result);
				$(".rating-table").html(result.Result.HtmlRating);
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			return false;
		});
	}

	// When selected a file get the file and store on Arquivo attachmentList[i]
	fileSelected() {
		var input: any = document.getElementById("fileRating");
		var file = input.files[0];
		this.uploadAttachment(file);
	}
	
    // Fuction to upload the attachment, receive the index of attachmentList obj
    uploadAttachment(file) {
        if (file.size / (1024 * 1024) > this.allowedFileSize) {
            this.flashMessagesService.show("Erro: O arquivo é maior que o permitido: " + this.allowedFileSize + " Mb", { cssClass: 'alert-danger', timeout: 6000 });
        } else {
            var formData = new FormData();
			formData.append('Arquivo', file);
			formData.append('Tipo', 'PF');

            this.limitFlowProposalService.insertRating(formData).subscribe(result => {
                if (result.Success) {
                    this.flashMessagesService.show("Template enviado com sucesso!", { cssClass: 'alert-success', timeout: 6000 });
					this.getRatingById(result.Result.ID);
					this.dre.DemonstrativoFinanceiroID = result.Result.ID;
					this.dre.Rating = result.Result.Rating;
					$("#dreObj").val(JSON.stringify(this.dre));
                } else {
					$("#fileRating").val("");
                    this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
                }
            }, error => {
                console.log(error);
            });
        }
	}
	
	getDreFile() {
		if (this.dre.DemonstrativoFinanceiroID != null)
		{
			this.limitFlowProposalService.getDreFile(this.dre.DemonstrativoFinanceiroID).subscribe(blob => {
				if (blob) {
					saveAs(blob, 'RatingPF' + "." + 'xls');
				} else {
					this.flashMessagesService.show("Problema ao baixar o arquivo", { cssClass: 'alert-danger', timeout: 6000 });
				}
			}, error => {
				console.log(error);
			});
		} else {
			this.flashMessagesService.show("Não existe nenhum arquivo disponível para download", { cssClass: 'alert-danger', timeout: 6000 });
		}
	}

	getDreModel() {
		let myFile = "/assets/files/rating_PF_-_versao_15_12_17.xlsx";
		var a = document.createElement('a');
		a.href = myFile;
		a.download = myFile.substr(myFile.lastIndexOf('/') + 1);
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
	}
}


// WEBPACK FOOTER //
// ./src/app/limit-flow-proposal/component/rating/rating.component.ts